import React from "react";
import RadioProperty from "./basic/RadioProperty";
import {fileEditorStore} from "../../stores/FileEditorStore";
import {observer} from "mobx-react-lite";
import {EditorModeType} from "../../service/Editor";

type Category = {
    type: EditorModeType
    name: string
}

const categories: Array<Category> = [
    {
        type: EditorModeType.ROUTES,
        name: "Routes"
    },
    {
        type: EditorModeType.CUT,
        name: "Cut"
    },
    {
        type: EditorModeType.DRILL,
        name: "Drills"
    },
    {
        type: EditorModeType.G_CODE_ZERO,
        name: "Set G-Code zero point"
    }
]

function EditorMode() {
    function handleRadioChange(value: EditorModeType) {
        fileEditorStore.setMode(value)
    }

    return <>
        {categories.map((category) => {
            return <RadioProperty
                key={category.type}
                id={category.type}
                label={category.name}
                category={"cat"}
                onChange={handleRadioChange}
                checked={fileEditorStore.currentMode === category.type}/>
        })}
    </>
}

export default observer(EditorMode)